export const installationClaimFormData = () => ({
  inputData: {
    is_active: true,
    installation_items: [
      {
        forceSave: true,
        id: null,
        is_installation_item_claimed: false,
        installation_claim_by: null,
        installation_claim_remark: "",
      },
    ],
  },
});

export const createPageData = () => {
  const payload = {
    checkAfterSave: true,
    actionType: "checkInstallationClaim",
    modelName: "installations",
    relation: [
      {
        modelName: "installation_items",
        moduleAs: "installations_items",
        foreignKey: "installation_id",
      },
    ],
   
  };

  const navigatePage = { back: "/installation-claim-list" };

  const headerName = "Installation Claim";

  const createEndpoint = "/updaterelationaldata";
  const getEndpoint = "/getInstallationDetails";
 
  return {
    payload,
    navigatePage,
    headerName,
    createEndpoint,
    getEndpoint,
  };
};

export const exportPageData = {
  data: {
    modelName: "installation_commissioning_list_masters",
    listInstallation: true,
    contractor_id: null,
    assignedTo: null,
    status: "installation_approved",
    whereCondition: {
      project_id: null,
      type: 1,
    },

    search: {
      searchKeyword: "",
      field_name: ["warehouse.warehouse_name", "contractor.first_name"],
    },
    pagination: { page: 1, pageSize: 100000 },
  },
  fileName: "installationClaimListData.xlsx",
};
